import React from 'react';
import './Confirm.css';

interface ConfirmProps {
    isOpen: boolean;
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const Confirm: React.FC<ConfirmProps> = ({
    isOpen,
    title = '확인',
    message,
    confirmText = '확인',
    cancelText = '취소',
    onConfirm,
    onCancel
}) => {
    if (!isOpen) return null;

    return (
        <div className="confirm-overlay" onClick={onCancel}>
            <div className="confirm-container" onClick={(e) => e.stopPropagation()}>
                <div className="confirm-content">
                    <h3 className="confirm-title">{title}</h3>
                    <p className="confirm-message">{message}</p>
                </div>
                <div className="confirm-footer">
                    <button className="confirm-button cancel" onClick={onCancel}>
                        {cancelText}
                    </button>
                    <button className="confirm-button confirm" onClick={onConfirm}>
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};
